

export class User {
	
	[index: string]: string | string[] | boolean | number[] | number | null;

	ebeId = '';
	ebeName = '';
	ebeVorname = '';
	ebeMail = '';
	ebeTelefon = '';

	// ebeRolleLogin = 'MITGLIED';

	// ebeFehlversucheLogin = '';
	jwtToken = '';
	// listOfWebGruppeBenutzer = [];

	ebePassword = '';
	ebePasswordCheck = '';

	mitgliedId = '';

	ebeAktiv = '';

	zweiFaktorAktive = false;
	zweiFaktorEmailPruefung = false;	// bEmailAuthenticator
	zweiFaktorPruefung = false;			// bAppAuthenticator
	zweiFaktorId = "";
	zweiFaktorToken = "";

	ebeRefreshToken = "";

	gruppen: string[] = [];				// UserRoles[]

  ebeVVID = "";
  ebeVVIDBedingung = false;

  ebeVVIDDatum = "";


	ebeChatNutzungsbedingungBestaetigt = false;

	ansStrasse = "";
	ansHausnummer = "";
	ansPlz = "";
	ansOrt = "";

	mitgliedsname = "";

	ebeLetzterLogin: number|null = null;

	ebeAnrede = "";
	ebeTitel = "";
	ebePosition = "";

	bMainContact = false;

}



export enum SecondStepType{ email, authenticator };


export enum UserRoles {
	MITGLIED_DATENPFLEGE = "MITGLIED_DATENPFLEGE",
	MITGLIED_DATENEXPORT = "MITGLIED_DATENEXPORT",
	MITGLIED_ADMIN = "MITGLIED_ADMIN",
	ADMIN = "ADMIN",
	MITGLIED = "MITGLIED",
	MITGLIED_AUSTAUSCH = "MITGLIED_AUSTAUSCH"
}
